import common from './common'
import sight from './modules/sight'
import vergence from './modules/vergence'
import eyemovement from './modules/eyemovement'

const therapy = {
  namespaced: true,
  ...common,
  modules: {
    sight,
    vergence,
    eyemovement,
  },

}

export default therapy
